const PRODUCT_IMG =
  'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/unyfq400_8.%20LumineX%20300.png';
const FEATURE_IMG =
  'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/unyfq400_8.%20LumineX%20300.png';

const lumineX300 = {
  slug: 'luminex-300',
  name: 'LumineX 300',
  testid: 'luminex',
  accent: 'blue',
  breadcrumb: { label: 'Floor Cleaning Robots', href: '/floor-cleaning-robots' },
  brochureUrl:
    'https://customer-assets.emergentagent.com/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/mw82al6s_LumineX%20300.pdf',
  meta: {
    title: 'LumineX 300 - Robot Vacuum & Mop | ₹29,990 | Harpalyk',
    description:
      'Buy LumineX 300 ⭐ AI robot vacuum & mop with up to 15,000Pa suction, LiDAR + AI navigation, 360° laser mapping, 3L self-emptying dock (70 days), HEPA filtration & 180-min runtime. Cleans up to 3,000 sq.ft. Only ₹29,990.',
    keywords:
      'LumineX 300, robot vacuum and mop, floor cleaning robot India, LiDAR robot vacuum, self emptying robot vacuum, 15000Pa robot vacuum, Harpalyk floor robot',
    canonical: 'https://harpalyk.com/products/luminex-300',
  },
  schema: {
    name: 'Harpalyk LumineX 300 Robot Vacuum & Mop',
    description:
      'LumineX 300 robot vacuum and mop with up to 15,000Pa suction, LiDAR + AI navigation, 360° laser mapping, simultaneous vacuum & mop, 3L self-emptying dock (up to 70 days), HEPA filtration and 180-minute runtime. Cleans up to 3,000 sq.ft.',
    image: PRODUCT_IMG,
    category: 'Robot Vacuum & Mop',
    price: '29990',
    ratingValue: '4.8',
    reviewCount: '74',
  },
  hero: {
    gradient: 'from-slate-900 via-blue-900 to-indigo-900',
    badge: 'SMARTBOT · Intelligent. Powerful. Effortless.',
    tagline: 'Robot Vacuum & Mop',
    description:
      'Total floor care, completely automated. One robot, two jobs — vacuum and mop together with up to 15,000Pa suction, LiDAR + AI navigation and a 3L self-emptying dock for up to 70 days hands-free.',
    price: { amount: '₹29,990', note: 'Inclusive of all taxes' },
    highlights: [
      { label: '15,000 Pa Suction', icon: 'Zap' },
      { label: 'LiDAR + AI Navigation', icon: 'Navigation' },
      { label: '3L Self-Empty Dock', icon: 'Trash2' },
      { label: 'Vacuum & Mop Together', icon: 'Droplets' },
    ],
    galleryAccent: 'blue',
    galleryBadge: 'Vacuum + Mop',
  },
  overview: {
    heading: 'Stronger. Smarter. Spotless.',
    sub: 'The LumineX 300 delivers total floor care, completely automated — combining powerful suction, simultaneous mopping and intelligent LiDAR navigation so your home stays effortlessly clean.',
    checklistTitle: 'One Robot. Two Jobs.',
    checklist: [
      'Vacuum and mop at the same time for a complete clean in one pass',
      'Up to 15,000Pa suction lifts fine dust, pet hair and embedded debris',
      '3L self-emptying dock runs hands-free for up to 70 days',
      'LiDAR + AI navigation maps and cleans your home systematically',
      'HEPA filtration captures fine dust and allergens for cleaner air',
      'Auto-switches to mopping and keeps off carpets while it mops',
      '180-minute runtime covers large homes on a single charge',
    ],
    panelGradient: 'from-blue-50 to-indigo-50',
    stats: [
      { value: '15,000 Pa', label: 'Max Suction' },
      { value: '180 min', label: 'Runtime' },
      { value: '3,000 ft²', label: 'Coverage' },
      { value: '3L', label: 'Self-Empty Dock' },
      { value: '70 Days', label: 'Hands-Free' },
      { value: 'HEPA', label: 'Filtration' },
    ],
  },
  features: {
    heading: 'Powerful Features for Spotless Floors',
    items: [
      { icon: 'Zap', title: 'Up to 15,000 Pa Suction', description: 'Powerful 8,000–15,000 Pa suction handles fine dust, pet hair, human hair, food crumbs and debris lodged deep in carpet fibres.' },
      { icon: 'Droplets', title: 'Vacuum & Mop Together', description: 'Sweeps and mops at the same time. Auto-switches to mopping once the water tank is installed for spotless, streak-free floors.' },
      { icon: 'Trash2', title: '3L Self-Emptying Dock', description: 'Large 3L dustbag auto-empties the robot — up to 70 days of completely hands-free, low-maintenance cleaning.' },
      { icon: 'Navigation', title: 'LiDAR + AI Navigation', description: '360° laser navigation with AI-powered mapping for precise, systematic coverage and intelligent obstacle avoidance.' },
      { icon: 'Timer', title: '180-Minute Runtime', description: 'Extended 180-minute battery life cleans large homes in a single run before automatically returning to the dock.' },
      { icon: 'Filter', title: 'HEPA Filtration', description: 'Captures fine dust particles and allergens for cleaner, healthier indoor air — ideal for homes with pets and kids.' },
      { icon: 'Map', title: 'Multi-Map Management', description: 'Saves multiple floor maps with rapid map drawing, so the robot recognises every level of your home instantly.' },
      { icon: 'Shield', title: 'Smart Restricted Areas', description: 'Set virtual no-go zones and keep the robot away from fragile items, pet bowls and delicate spaces.' },
      { icon: 'Layers', title: 'Intelligent Partition', description: 'Automatically divides your home into rooms for organised, room-by-room cleaning with an optimised arch-line path.' },
      { icon: 'Wind', title: 'Keeps Off Carpets When Mopping', description: 'Detects and avoids carpets during mopping so rugs stay dry while hard floors get a thorough wet clean.' },
    ],
  },
  sections: [
    {
      type: 'split',
      label: 'Cleaning Power',
      heading: 'Up to 15,000 Pa Suction',
      desc: 'This level of suction is engineered to lift everything from invisible fine dust to stubborn debris trapped deep in carpet fibres — leaving your floors genuinely spotless.',
      itemVariant: 'chips',
      itemIcon: 'Sparkles',
      items: [
        { title: 'Fine dust particles' },
        { title: 'Pet hair' },
        { title: 'Human hair' },
        { title: 'Food crumbs' },
        { title: 'Dirt tracked in from shoes' },
        { title: 'Debris lodged in carpet fibres' },
      ],
      panel: {
        gradient: 'from-blue-600 to-indigo-700',
        title: '360° Laser Navigation Cleaning',
        desc: 'LiDAR + AI navigation with rapid map drawing, multi-map management, intelligent partitioning and an optimised arch-line path ensures complete, systematic coverage of your entire home.',
        subClass: 'text-blue-100',
        statClass: 'text-blue-200',
        stats: [
          { value: '180', label: 'Min Runtime' },
          { value: '3,000', label: 'sq.ft. Coverage' },
        ],
      },
    },
    {
      type: 'darkCards',
      label: 'Hands-Free Cleaning',
      heading: 'Spotless Floors. Less Effort.',
      sub: 'The 3L self-emptying dock and simultaneous vacuum-and-mop system mean you can set it and forget it for weeks at a time.',
      cards: [
        { icon: 'Trash2', title: '3L Self-Emptying Dock', desc: "Automatically empties the robot's dustbin into a large 3L dustbag, giving you up to 70 days of completely hands-free cleaning.", badge: 'Up to 70 Days' },
        { icon: 'Droplets', title: 'Vacuum & Mop Together', desc: 'Auto-switches to mopping once the tank is installed, mops evenly with no water stains, and keeps off carpets while mopping.', badge: 'One Pass Clean' },
        { icon: 'Filter', title: 'HEPA Filtration', desc: 'Captures fine dust particles and allergens for cleaner, healthier indoor air — perfect for homes with pets and frequent dust.', badge: 'Cleaner Air' },
      ],
    },
    {
      type: 'imageSplit',
      image: FEATURE_IMG,
      imageAlt: 'LumineX 300 features - vacuum and mop, LiDAR navigation, HEPA filtration',
      label: "Why You'll Love It",
      heading: 'Perfect for Every Home',
      items: [
        { title: 'Saves Time', desc: 'Cleans and mops in one go — no more switching tools or doing it twice.' },
        { title: 'Cleaner Floors', desc: 'Removes dirt and dust better with up to 15,000 Pa of suction power.' },
        { title: 'Smart & Safe', desc: 'Avoids obstacles and fragile items with LiDAR + AI navigation.' },
        { title: 'No Water Stains', desc: 'Mops evenly and leaves your floors dry and streak-free.' },
      ],
      tags: ['Pet Hair', 'Large Homes', 'Frequent Dust', 'Low Maintenance'],
    },
  ],
  specs: {
    defaultTab: 'general',
    tabs: [
      { id: 'general', label: 'General' },
      { id: 'cleaning', label: 'Cleaning' },
      { id: 'navigation', label: 'Navigation' },
      { id: 'dock', label: 'Dock & Maintenance' },
    ],
    data: {
      general: [
        { label: 'Model Name', value: 'LumineX 300' },
        { label: 'Type', value: 'Robot Vacuum & Mop' },
        { label: 'Suction Power', value: 'Up to 15,000 Pa' },
        { label: 'Coverage Area', value: 'Up to 3,000 sq.ft.' },
        { label: 'Runtime', value: '180 Minutes' },
        { label: 'Filtration', value: 'HEPA Filter' },
      ],
      cleaning: [
        { label: 'Cleaning Modes', value: 'Vacuum + Mop (Simultaneous)' },
        { label: 'Suction Range', value: '8,000 – 15,000 Pa' },
        { label: 'Mopping', value: 'Auto-switch After Tank Install' },
        { label: 'Carpet Handling', value: 'Auto Carpet Avoidance (Mopping)' },
        { label: 'Mop Result', value: 'Even Mopping, No Water Stains' },
        { label: 'Dust Capture', value: 'HEPA Fine Dust & Allergens' },
      ],
      navigation: [
        { label: 'Navigation System', value: 'LiDAR + AI' },
        { label: 'Laser Scanning', value: '360° Laser Navigation' },
        { label: 'Mapping', value: 'Rapid Map Drawing' },
        { label: 'Multi-Floor Maps', value: 'Multi-Map Management' },
        { label: 'Zoning', value: 'Intelligent Partition' },
        { label: 'No-Go Zones', value: 'Smart Restricted Areas' },
      ],
      dock: [
        { label: 'Dock Type', value: '3L Self-Emptying Dock' },
        { label: 'Auto-Empty Capacity', value: 'Up to 70 Days' },
        { label: 'Maintenance', value: 'Hands-Free Operation' },
        { label: 'Charging', value: 'Auto Return & Recharge' },
        { label: 'Path Planning', value: 'Optimised Arch-Line' },
        { label: 'Ideal For', value: 'Pet Hair, Large Homes, Frequent Dust' },
      ],
    },
  },
  contact: {
    heading: 'Ready for Effortlessly Clean Floors?',
    sub: 'Upgrade to the LumineX 300 — vacuum and mop together for just ₹29,990. Contact us today for availability and a free demo.',
    gradient: 'from-blue-600 to-indigo-700',
  },
  faqs: [
    {
      question: 'Can the LumineX 300 vacuum and mop at the same time?',
      answer:
        'Yes. The LumineX 300 sweeps and mops simultaneously. Once you install the water tank it automatically switches to mopping mode, cleaning and mopping your floors in a single pass to save time and deliver spotless results.',
    },
    {
      question: 'How long can it run without me emptying it?',
      answer:
        'The 3L self-emptying dock automatically empties the robot after each clean, giving you up to 70 days of completely hands-free operation. Combined with the 180-minute runtime, the LumineX 300 keeps large homes clean with virtually no maintenance.',
    },
    {
      question: 'How powerful is the suction?',
      answer:
        'The LumineX 300 delivers up to 15,000 Pa of suction (8,000–15,000 Pa range). This is strong enough to handle fine dust particles, pet hair, human hair, food crumbs, dirt tracked in from shoes and debris lodged deep in carpet fibres.',
    },
    {
      question: 'How does it navigate my home?',
      answer:
        'It uses LiDAR + AI with 360° laser navigation for precise, systematic cleaning. Features include rapid map drawing, multi-map management for different floors, intelligent partitioning of rooms, an optimised arch-line cleaning path and smart restricted areas to keep it away from no-go zones.',
    },
    {
      question: 'Will it mop my carpets by mistake?',
      answer:
        'No. The LumineX 300 intelligently detects and keeps off carpets during mopping, so your rugs stay dry while your hard floors get a thorough wet clean. It also mops evenly to leave floors dry with no water stains.',
    },
  ],
  related: [
    { label: 'All Floor Robots', href: '/floor-cleaning-robots' },
    { label: 'HygienX 300', href: '/products/hygienx-300' },
    { label: 'Robo Dressel Pool Robot', href: '/products/robo-dressel' },
    { label: 'Window Cleaning Robots', href: '/window-cleaning-robots' },
    { label: 'View All Products', href: '/#products' },
  ],
};

export default lumineX300;
